@if(!showDescriptions) {
<img src="../../../../../assets/img/PDS.png" alt="" [@imageToggle] />
}

<h2>Choisissez une Étape du parcours</h2>

<app-care-pathway-stepper
  [steps]="carePathwaySteps"
  variant="global"
  (stepSelected)="onClickStep($event)"
></app-care-pathway-stepper>

@if (showDescriptions) {
<div
  class="descriptions care-pathway-stepper-grid care-pathway-stepper-grid--{{
    carePathwaySteps.length
  }}"
  [@descriptionExpand]
>
  @for (step of carePathwaySteps; track $index) {
  <p [innerHTML]="step.description"></p>
  }
</div>
}

<!-- <div class="expand-button-container">
  <button class="expand-button" mat-icon-button (click)="onClickToggleExpand()">
    <mat-icon [class.collapse]="showDescriptions">keyboard_arrow_down</mat-icon>
  </button>
</div> -->
